import { render, staticRenderFns } from "./WarehouseLoadDetails.vue?vue&type=template&id=99373fe0&"
import script from "./WarehouseLoadDetails.vue?vue&type=script&lang=js&"
export * from "./WarehouseLoadDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports